// frontend/src/hooks/useChallenges.ts

import { useEffect, useState, useCallback } from 'react';
import { authService } from '../services/auth.service';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

export interface Challenge {
  id: string;
  title: string;
  description: string;
  period: 'daily' | 'weekly';
  xp_reward: number;
  completed: boolean;
}

export function useChallenges() {
  const [challenges, setChallenges] = useState<Challenge[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const reload = useCallback(async () => {
    setIsLoading(true);
    try {
      const token = await authService.getAccessToken();
      const res = await fetch(`${API_BASE}/api/challenges`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setChallenges(data.challenges ?? []);
    } catch {
      setChallenges([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  async function complete(challengeId: string): Promise<number> {
    const token = await authService.getAccessToken();
    const res = await fetch(`${API_BASE}/api/challenges/${challengeId}/complete`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    await reload();
    return data.xpAwarded ?? 0;
  }

  return { challenges, isLoading, complete, reload };
}
